import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import Foot from "../../../../components/Math/Units/Imperial/Foot";
import Metre from "../../../../components/Math/Units/Metric/Metre";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectInclinedLengthSum } from "../../../../store/slices/aashtoSlice";

function InclinedLengthSum() {
  const { t } = useTranslation("translation");

  const inclinedLengthSum = useSelector(selectInclinedLengthSum);

  return (
    <RowBody
      titleValue={<p>{t("aashto.ausser.Length")}</p>}
      inputValue={
        <span className="input">
          <NumberFormatText prefix="INF" value={inclinedLengthSum.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />}
    />
  );
}

export default InclinedLengthSum;
